import axios from "axios";
import { getAccessToken } from "./helpers";
import { mysphereAPIURL } from "../app/auth/util/CustomConstants";


export const createAIChatSession = async (data) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "user-auth-session": `${localStorage.getItem("userAuthSessionID")}`,
    };

    return await axios.post(
        `${mysphereAPIURL}/api/v1/ai-chat/create`,
        data,
        { headers }
    );
}

export const generateQuestion = async (id, chapterIndex = null) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "user-auth-session": `${localStorage.getItem("userAuthSessionID")}`,
    };

    return await axios.get(
        `${mysphereAPIURL}/api/v1/ai-chat/${id}/generate-question?chapter=${chapterIndex}`,
        { headers }
    );
}

export const fetchAIChatBlocks = async (id, questionIndex, chapter) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "user-auth-session": `${localStorage.getItem("userAuthSessionID")}`,
    };

    return await axios.post(
        `${mysphereAPIURL}/api/v1/ai-chat/${id}`,
        {questionIndex, chapter},
        { headers }
    );
}

export const helperPrompt = async (id, data) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "user-auth-session": `${localStorage.getItem("userAuthSessionID")}`,
    };

    return await axios.post(
        `${mysphereAPIURL}/api/v1/ai-chat/${id}/helper-prompt`,
        data,
        { headers }
    );
}

export const listAIChatSessions = async (type) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "user-auth-session": `${localStorage.getItem("userAuthSessionID")}`,
    };

    return await axios.get(
        `${mysphereAPIURL}/api/v1/ai-chat/list?type=${type}`,
        { headers }
    );
}

export const listXPs = async () => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "user-auth-session": `${localStorage.getItem("userAuthSessionID")}`,
    };

    return await axios.get(
        `${mysphereAPIURL}/api/v1/ai-chat/list-xp`,
        { headers }
    );
}

export const userAttempt = async (id, chapterIndex = null, data) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "user-auth-session": `${localStorage.getItem("userAuthSessionID")}`,
    };

    return await axios.post(
        `${mysphereAPIURL}/api/v1/ai-chat/${id}/user-attempt${chapterIndex !== null ? '?chapter='+chapterIndex : ''}`,
        data,
        { headers }
    );
}

export const deleteAIChatSession = async (id) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "user-auth-session": `${localStorage.getItem("userAuthSessionID")}`,
    };

    return await axios.delete(
        `${mysphereAPIURL}/api/v1/ai-chat/${id}`,
        { headers }
    );
}

// Below are the new services for organization assessments 

export const createCohortAssessment = async (data) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "user-auth-session": `${localStorage.getItem("userAuthSessionID")}`,
    };

    return await axios.post(
        `${mysphereAPIURL}/api/v1/ai-chat/org-cohort-assessment/create`,
        data,
        { headers }
    );
}

export const userAttemptCohortAssessmentQuestion = async (id, data) => {
    const accessToken = await getAccessToken();
    const headers = {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
        "user-auth-session": `${localStorage.getItem("userAuthSessionID")}`,
    };

    return await axios.post(
        `${mysphereAPIURL}/api/v1/ai-chat/org-cohort-assessment/${id}/user-attempt`,
        data,
        { headers }
    );
}